import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const BurgerIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M16 13c0 .552-.512 1-1.143 1H1.143C.512 14 0 13.552 0 13s.512-1 1.143-1h13.714c.631 0 1.143.448 1.143 1ZM16 8c0 .552-.512 1-1.143 1H1.143C.512 9 0 8.552 0 8s.512-1 1.143-1h13.714C15.488 7 16 7.448 16 8ZM14.857 4C15.488 4 16 3.552 16 3s-.512-1-1.143-1H1.143C.512 2 0 2.448 0 3s.512 1 1.143 1h13.714Z", fill: "currentColor" })));
});
BurgerIcon.displayName = 'BurgerIcon';
export default BurgerIcon;
